import { render } from "./TermsConditions.vue?vue&type=template&id=2f22521a&scoped=true&ts=true"
import script from "./TermsConditions.vue?vue&type=script&lang=ts"
export * from "./TermsConditions.vue?vue&type=script&lang=ts"

import "./TermsConditions.vue?vue&type=style&index=0&id=2f22521a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f22521a"]])

export default __exports__